import {
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import BakeasyLabelText from '../../components/lables/BakeasyLabelText';
import { AppContext } from '../../context/AppContext';
import { useAppSelector } from '../../redux_store/reduxStore';
import { ordersState } from '../../redux_store/slices/ordersSlice';
import { formatDateTime } from '../../utils/DateUtils';
import { invoiceState } from '../../redux_store/slices/invoiceSlice';
import { t } from 'i18next';
import { Close } from '@mui/icons-material';

interface StoreNotesHistoryProps {
  from: string;
}

export const StoreNotesHistory: React.FC<StoreNotesHistoryProps> = ({
  from,
}) => {
  let myContext = React.useContext(AppContext);

  const { selectedValue }: any = useAppSelector(
    from === 'orderDetails'
      ? ordersState
      : from === 'invoiceDetails'
        ? invoiceState
        : () => ({ selectedValue: null })
  );
  const [data, setData] = useState([]);

  function handleClose() {
    myContext.setDialog({ open: false });
  }

  useEffect(() => {
    if (selectedValue?.storeNotes && selectedValue?.storeNotes.length > 0) {
      setData(selectedValue?.storeNotes);
    }
  }, [selectedValue]);

  return selectedValue?.storeNotes.length > 0 ? (
    <>
      <DialogTitle
        sx={{ margin: 0, padding: 2 }}
        style={{ fontWeight: 600, fontSize: '1.2rem' }}
        minWidth={200}
      >
        <Grid container sx={{ flexDirection: 'row' }}>
          {t('STORE_NOTES')}
        </Grid>
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Close />
      </IconButton>
      <Divider />
      <DialogContent sx={{ margin: 0 }}>
        {data?.map((item: any, index: number) => (
          <Grid key={index} sx={{ marginBottom: '15px' }}>
            <BakeasyLabelText
              label={formatDateTime(item.date)}
              value={item.notes}
            />
          </Grid>
        ))}
      </DialogContent>
    </>
  ) : null;
};
